
// import './transforms/sliders.scss';
import Sliders from "./transforms/Sliders";
// import './transforms/composition.scss';
import Composition from './transforms/Composition';
// import './transforms/passTransformation.scss';
import PassTransformation from "./transforms/PassTransformation";
// import './transforms/onepunchman.scss';
import OnepunchMan from "./transforms/OnepunchMan";
// import './transforms/onepunchman2.scss';
import OnepunchMan2 from "./transforms/OnepunchMan2";
// import './typography/loading.scss';
import LoadingText from "./typography/LoadingText";
// import './typography/funwords.scss';
import FunWords from "./typography/FunWords";
// import './typography/animation.scss';
import Animation from "./typography/Animation";
// import './flips/sliders.scss';
import FlipSliders from "./flips/FlipsSlider";
// import './flips/passflips.scss';
import PassFlips from "./flips/PassFlips";
// import './flips/venture.scss';
import Venture from "./flips/Venture";
// import './flips/observer.scss';
import Observers from "./flips/Observer";
// import './flips/dashtext.scss';
import DashingText from "./flips/DashingText";


import CanvasComponent from "./canvas/CanvasComponent";
import Borders from "./kazeflips/Borders";
// import "./kazeflips/borders.scss";
// import "./kazeflips/entitle.scss";

import Reverting from "./contexts/Reverting";
// import "./contexts/reverting.scss";
import KazeScroll from "./kazescrolls/KazeScroll";
// import "./kazescrolls/kazescroll.scss";

import Anim1 from "./animations/Anim1";
// import "./animations/anim1.scss";
import Product from "./productions/Product";
import "./productions/product.scss";

function App() {
  return (
    <div className="App">
      {/* <Sliders/> */}
      {/* <Composition/> */}
      {/* <PassTransformation/> */}
      {/* <OnepunchMan/> */}
      {/* <OnepunchMan2/> */}
      {/* <LoadingText/> */}
      {/* <FunWords/> */}
      {/* <Animation/> */}
      {/* <FlipSliders/> */}
      {/* <PassFlips/> */}
      {/* <Venture/> */}
      {/* <Observers/> */}
      {/* <DashingText/> */}
      {/* <CanvasComponent/> */}
      {/* <Borders/> */}
      {/* <Reverting/> */}
      {/* <KazeScroll/> */}
      {/* <Anim1/> */}
      <Product/>
    </div>
  );
}

export default App;
